import { z } from "zod";

const userSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  email: z.email(),
  phone: z.string().nullable(),
  created_at: z.iso.datetime({ offset: true }),
});

export type User = z.infer<typeof userSchema>;

export { userSchema };
